module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_2.480936f8.png";